import { render, staticRenderFns } from "./tblBtncomponents.vue?vue&type=template&id=fedd45f2&"
import script from "./tblBtncomponents.vue?vue&type=script&lang=js&"
export * from "./tblBtncomponents.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports